
import * as React from "react";

interface Props {
    defaultValue?: string | boolean,
    onSubmit: Function,
    inputType?: string
}
interface State {
    value?: string | boolean,
    isEditing?: boolean,
    inputValue?: string | boolean
}

export class QuickEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {value: props.defaultValue, isEditing: false, inputValue: props.defaultValue};
    }

    toggleEdit() {
        this.setState({isEditing: !this.state.isEditing});
    }

    submit() {
        this.props.onSubmit(this.state.inputValue);
        this.toggleEdit();
    }

    handleChange(event: any){
        let value = this.props.inputType === "checkbox" ? event.currentTarget.checked : event.currentTarget.value;
        this.setState({ inputValue: value });
    }

    render() {
        let inputType = this.props.inputType || "text";
        return (
            <span>
                {!this.state.isEditing ? this.props.defaultValue+ "": ""}
                {!this.state.isEditing && (
                    <span>&nbsp;&nbsp;
                    <a  href="/#" onClick={(e: any) => { e.preventDefault(); this.toggleEdit();}}><i className="fe-edit"></i></a>
                    </span>
                )}

                {this.state.isEditing && (
                    <span>
                        <input 
                            type={inputType} size={5}
                            defaultValue={inputType !== "checkbox" ? this.props.defaultValue +"" : undefined}
                            checked={inputType === "checkbox" ? this.state.inputValue === true : undefined}
                            onChange={e => this.handleChange(e)}
                            autoFocus onFocus={e => e.currentTarget.select()} 
                        /> <a href="/#" onClick={(e:any) => { e.preventDefault(); this.submit();}}><i className="fe-check"></i>
                        </a> <a href="/#" onClick={(e:any) => { e.preventDefault(); this.toggleEdit();}}><i className="fe-x"></i></a>
                    </span>
                )}
            </span>
        );
    }
}
